import { MenuItem, type MenuItemProps, RevelioTooltip } from '@revelio/ui';

export interface MenuItemWithDisabledReasonProps extends MenuItemProps {
  disabledReason: string;
  isDisabled?: boolean;
}

export const MenuItemWithDisabledReason = ({
  disabledReason,
  isDisabled,
  disabled,
  ...menuItemProps
}: MenuItemWithDisabledReasonProps) => {
  const shouldDisable = isDisabled ?? disabled;
  const item = <MenuItem disabled={shouldDisable} {...menuItemProps} />;

  if (!shouldDisable) return item;

  return (
    <RevelioTooltip label={disabledReason} placement="right" fullWidthTrigger>
      {item}
    </RevelioTooltip>
  );
};
